<template lang="pug">
a(:class="classes" @click="startDownloadTrial()") {{ copy }}
</template>

<script>
import compareVersions from 'compare-versions';
import EventBus from '../eventBus.js';

export default {
  name: 'download-trial-button',
  props: {
    product: String,
    copy: String,
    link: String,
    classes: String,
  },
  methods: {
    startDownloadTrial() {
      const currentURL = window.location.pathname;
      if (bowser.osname === 'macOS') {
        // Turn on download Trial Modal
        EventBus.$emit('closeWatermarkEmbed');
        EventBus.$emit('showModal');
        ga('send', 'event', 'Download', 'Button Click', this.product);
        const path = 'products/mac/' + this.product + '/download';
        let osVersion = bowser.osversion;
        if (bowser.gecko || bowser.osversion === '10.14') {
          osVersion = bowser.osversion +'.0';
        }

        if (compareVersions(osVersion, '10.12.2')) {
          window.location = path;
        } else {
          if (this.product === 'pro') {
            if (!compareVersions(osVersion, '10.12.2')
                  && !compareVersions(osVersion, '>=10.11.*')) {
              window.location = 'products/mac/cinemagraph-pro/download/latest/2.3';
            } else if (compareVersions(osVersion, '10.10.*')
                      || compareVersions(osVersion, '10.9.*')) {
              window.location = 'products/mac/cinemagraph-pro/download/latest/1.9.3';
            }
          } else if (product === 'persecond') {
            window.location = 'products/mac/persecond/download/latest/1.0.9';
          }
        }
      } else {
        if (this.product === 'pro') {
          alert('Cinemagraph Pro is not available on your platform.');
        } else if (this.product === 'persecond') {
          alert('Persecond is not available on your platform.');
        } else if (this.product === 'screensaver') {
          alert('Flixel Screensaver is not available for your platform.');
        } else if (this.product === 'blendeo') {
          alert('Blendeo is not available for your platform.');
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/downloadTrialButton.vue